export default __webpack_public_path__ + "static/media/linkedin.f448f212.svg";